import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './assets/css/style.css';
import './App.css'
import { Provider } from "react-redux";
import { store, persistor } from "./store/index";
import { PersistGate } from 'redux-persist/integration/react';
//import { HashRouter as Router } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoute from './AppRoute';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useState, useEffect } from 'react';
import IdleTimer from './IdleTimer';
import ApiService from './services/ApiService';
import { SUCCESS_STATUS } from './constants/Config';

function App() {

 // const [isTimeout,setIsTimeout] = useState(false)
  useEffect(() => {
    const timer = new IdleTimer({
      timeout: localStorage.getItem('_inactiveTimeout')? Number(localStorage.getItem('_inactiveTimeout'))*60 : 600,
      onTimeout:()=>{
        if(localStorage.getItem("_token")){
          callLogOut();
        }
       
        // localStorage.clear()
        // window.location.reload();
        //setIsTimeout(true)
      }
    })
  
    return () => {
      timer.cleanUp()
    }
  }, [])



  const callLogOut = async()=>{
    try {
      const result = await ApiService.postData(`logoutMagma`, {});
      if (result.status === SUCCESS_STATUS) {
          localStorage.removeItem('_token');
          localStorage.clear()
          window.location.reload();
         
      }        
      toast.error("Something went wrong")

    } catch (error) {
        toast.error("Something went wrong")
    }
  }
  

  return (
    <>
    <Provider store={store}>
    <PersistGate persistor={persistor}>
    {/* FOR PROD */}
       <Router basename='/'>
      {/* FOR UAT  */}
      {/* <Router basename='/magma-portal'> */}
        <AppRoute/>
        <ToastContainer autoClose={3000} />
      </Router>
    </PersistGate>
    </Provider>
    </>
  );
}

export default App;
